import { AnalyticsEventType } from '@prisma/client';
import { z } from 'zod';

export const CreateAnalyticsEvent = z.object({
    eventType: z.nativeEnum(AnalyticsEventType),
    userId: z.string().optional(),
    userRole: z.string().optional(),
    submissionDetailsId: z.number().optional(),
    metadata: z.record(z.unknown()).optional(),
});

export type CreateAnalyticsEventType = z.infer<typeof CreateAnalyticsEvent>;
